import { Alert, Snackbar } from "@mui/material";
import { connectedRef, useValue } from "@ssf/play-components";
import { CloudOffOutline } from "mdi-material-ui";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const FirebaseConnectionStatus = () => {
  const { t } = useTranslation("FirebaseConnectionStatus");
  const { data: connected } = useValue(connectedRef)<boolean>();
  const [showOfflineError, setShowOfflineError] = useState(false);

  useEffect(() => {
    const timeout = window.setTimeout(() => setShowOfflineError(true), 5000);
    return () => window.clearTimeout(timeout);
  }, []);

  if (!showOfflineError || connected !== false) {
    return null;
  }

  return (
    <Snackbar open>
      <Alert severity="error" icon={<CloudOffOutline />} variant="filled">
        {t("offline")}
      </Alert>
    </Snackbar>
  );
};
